import { useEffect, useState } from "react";
import { getUserToken } from "../../../helper/commonFunction";
import { ApiCall } from "../../../helper/axios";
import { useNavigate } from "react-router-dom";

const unwrapTicketsResponse = (details) => {
  const body = details?.data;
  return body?.statusCode && body?.data ? body.data : body;
};

export const useGetTickets = (IsEventBased, commonId) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [convertToAdult, setConvertToAdult] = useState(false);
  const [groupData, setGroupData] = useState({});
  let userToken = getUserToken();

  const refresh = async ({
    time,
    endTime,
    variationId,
    eventId,
    adults,
    child,
    infants,
    id,
    date
  }) => {
    let payload = {
      VariationId: variationId,
      excursionId: id,
      EventID: eventId,
      StartDateTime: time,
      EndDateTime: endTime,
      IsEventBased,
      ...(commonId ? { commonId } : {})
    }
    if (IsEventBased === 'false') {
      payload.StartDateTime = date,
        payload.EndDateTime = date
    }
    try {
      setLoading(true);
      setError(null);
      const details = await ApiCall(
        "POST",
        `/excursions/get-tickets`,
        payload,
        {}
      );
      const responseBody = unwrapTicketsResponse(details);
      if (!responseBody?.ResultStatus) {
        throw new Error("Something went wrong, please try again after sometime");
      }
      setData(responseBody?.ResponseData?.Tickets);
      setConvertToAdult(responseBody?.convertToAdult)

      const adultGroup = responseBody?.ResponseData?.Tickets?.find(
        (d) => d?.TicketGroup === "Adult"
      );
      const childGroup = responseBody?.ResponseData?.Tickets?.find(
        (d) => d?.TicketGroup === "Child"
      );
      const infantGrup = responseBody?.ResponseData?.Tickets?.find(
        (d) => d?.TicketGroup === "Infant"
      );

      setGroupData({
        adultGroup,
        childGroup,
        infantGrup,
      });
      let message;
      if (child > 0 && !childGroup) {
        message = `Child not allowed for given slot and event, Please check another time.`;
      } else if (infants > 0 && !infantGrup) {
        message = `Infants not allowed for given slot and event, Please check another time.`;
      }
      if (message) {
        throw new Error(message)
      }
    } catch (error) {
      setError(error?.message);
    } finally {
      setLoading(false);
    }
  };

  const getEmaarV1Tickets = async ({
    excursionId,
    EventID,
    EventName,
    StartDateTime,
    EndDateTime,
    EventTypeId,
    ResourceID,
    Available,
    Status,
    Infant, Child, Adult
  }) => {
    let payload = {
      isEmaarV1: true,
      excursionId,
      EventID,
      StartDateTime,
      EventName,
      EndDateTime,
      EventTypeId,
      ResourceID,
      Available,
      Status,
      ...(commonId ? { commonId } : {})
    }
    try {
      setLoading(true);
      setError(null);
      const details = await ApiCall(
        "POST",
        `/excursions/get-tickets`,
        payload,
        {}
      );
      const responseBody = unwrapTicketsResponse(details);
      if (!responseBody?.ResultStatus) {
        throw new Error("Something went wrong, please try again after sometime");
      }
      const adultGroup = responseBody?.ResponseData?.Tickets?.find(
        (d) => d?.v_Group === "Adult"
      );
      const childGroup = responseBody?.ResponseData?.Tickets?.find(
        (d) => d?.v_Group === "Child"
      );
      const infantGrup = responseBody?.ResponseData?.Tickets?.find(
        (d) => d?.v_Group === "Infant"
      );

      let message;
      if (Child > 0 && !childGroup) {
        message = `Child not allowed for given slot and event, Please check another time.`;
      } else if (Infant > 0 && !infantGrup) {
        message = `Infants not allowed for given slot and event, Please check another time.`;
      }
      if (message) {
        throw new Error(message)
      }

      const updatedTickets = responseBody?.ResponseData?.Tickets?.map(ticket => {
        let qty = 0;
        if (ticket.v_Group === "Adult") qty = Adult;
        else if (ticket.v_Group === "Child") qty = Child;
        else if (ticket.v_Group === "Infant") qty = Infant;

        return {
          ...ticket,
          Qty: String(qty)
        };
      });
      setData(updatedTickets);
    } catch (error) {
      setError(error?.message);
    } finally {
      setLoading(false);
    }
  }

  return {
    refresh,
    getEmaarV1Tickets,
    data,
    loading,
    error,
    setError,
    groupData,
    convertToAdult,
  };
};
